interface WorkflowStepContract {
  displayName?: string | null;
  name?: string | null;
}
export const getWorkflowStepDisplayName = (
  step?: WorkflowStepContract | null,
) => step?.displayName || step?.name || "";
